import confetti from 'canvas-confetti'

export function launchCelebrationConfetti() {
	try {
		// First wave - center burst
		confetti({
			particleCount: 100,
			spread: 70,
			origin: { y: 0.6 }
		})
		
		// Second wave - left side
		setTimeout(() => {
			confetti({
				particleCount: 50,
				spread: 60,
				origin: { y: 0.7, x: 0.2 }
			})
		}, 200)
		
		// Third wave - right side
		setTimeout(() => {
			confetti({
				particleCount: 50,
				spread: 60,
				origin: { y: 0.7, x: 0.8 }
			})
		}, 400)
		
	} catch (error) {
		console.error('Error launching celebration confetti:', error)
	}
} 